import { render, staticRenderFns } from "./AISystem.vue?vue&type=template&id=b060b82c&scoped=true&"
import script from "./AISystem.vue?vue&type=script&lang=js&"
export * from "./AISystem.vue?vue&type=script&lang=js&"
import style0 from "./AISystem.vue?vue&type=style&index=0&id=b060b82c&lang=less&scoped=true&"
import style1 from "./AISystem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b060b82c",
  null
  
)

export default component.exports